import {
  Directive,
  ElementRef,
  Input,
  HostListener,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {
  @Input('appTooltip') tooltipText = '';

  private tooltipElement: HTMLElement | null = null;

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.tooltipText) return;

    const tooltip = this.renderer.createElement('span');
    this.renderer.setProperty(tooltip, 'innerText', this.tooltipText);

    const rect = this.el.nativeElement.getBoundingClientRect();
    this.renderer.setStyle(tooltip, 'position', 'fixed');
    this.renderer.setStyle(tooltip, 'top', `${rect.top - 30}px`);
    this.renderer.setStyle(tooltip, 'left', `${rect.left}px`);
    this.renderer.setStyle(tooltip, 'background', '#333');
    this.renderer.setStyle(tooltip, 'color', '#fff');
    this.renderer.setStyle(tooltip, 'padding', '4px 8px');
    this.renderer.setStyle(tooltip, 'borderRadius', '4px');
    this.renderer.setStyle(tooltip, 'fontSize', '12px');
    this.renderer.setStyle(tooltip, 'zIndex', '9999');
    this.renderer.setStyle(tooltip, 'pointerEvents', 'none');
    this.renderer.setStyle(tooltip, 'whiteSpace', 'nowrap');
    this.renderer.setStyle(tooltip, 'boxShadow', '0px 2px 6px rgba(0,0,0,0.2)');

    this.tooltipElement = tooltip;
    this.renderer.appendChild(document.body, tooltip);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = null;
    }
  }
}
